const { forEach, map } = require('lodash');

class TrackMyOrderGuestFormController {
    constructor($scope, $state, $timeout, tmoService, analyticsService, moveFocus) {
        this.$scope = $scope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.tmoService = tmoService;
        this.analyticsService = analyticsService;
        this.moveFocus = moveFocus;
    }

    $onInit() {
        this.values = {
            OrderNumber: undefined,
        };

        if (this.$state.params.OrderNumber) {
            this.values.OrderNumber = parseInt(this.$state.params.OrderNumber);
        }
    }

    $postLink() {
        if (this.values.OrderNumber) {
            this.submit();
        }
    }

    submit() {
        this._clearTmoDisplay();
        this._validateTmoForm();

        if (!this.tmoForm.$valid) {
            return;
        }

        this.isLoading = true;
        this.selectedOrderId = this.values.OrderNumber;
        this.tmoService.getOrderInfo(this.selectedOrderId).then((response) => {
            this.tmoInfo = response;
            this.isClickAndCollect = response.IsClickAndCollect;
            if (this.tmoInfo.InfoMessage || this.tmoInfo.ErrorMessage) {
                this.moveFocus('#trackmyorderGuestForm-messagesContainer');
                this.errorMessage = this.tmoInfo.ErrorMessage;
                this.infoMessage = this.tmoInfo.InfoMessage;
                if (this.tmoInfo.ErrorMessage) {
                    this.analyticsService.pushError(this.tmoInfo.ErrorMessage);
                }
            } else {
                this.errorMessage = undefined;
                this.infoMessage = undefined;
            }
            this.submitClicked = true;
            this.isLoading = false;
        }).catch((response) => {
            this.isLoading = false;
            this.serverErrors = {};
            if (response.data && response.data.ResponseStatus) {
                forEach(response.data.ResponseStatus.Errors, (n) => {
                    if (this.tmoForm[n.FieldName]) {
                        this.tmoForm[n.FieldName].$setValidity('serverError', false);
                        this.tmoForm.$invalid = true;
                    }
                    this.serverErrors[n.FieldName] = n.Message;
                });
                this.analyticsService.pushErrors(map(response.data.ResponseStatus.Errors, 'Message'));
            }
            this.submitClicked = false;
        });
    }

    clearValidationErrors() {
        this.serverErrors = {};
        if (!this.tmoForm.OrderNumber.$valid) {
            this.tmoForm.OrderNumber.$setValidity('required', 'true');
            this.tmoForm.OrderNumber.$setValidity('number', 'true');
            this.tmoForm.OrderNumber.$setValidity('serverError', 'true');
        }
    }

    resetTmoPanel() {
        this._clearTmoForm();
        this.$timeout(() => {
            this.moveFocus('#trackmyorderGuestForm');
        });
    }

    _clearTmoDisplay() {
        this.tmoInfo = undefined;
        this.isClickAndCollect = undefined;
        this.IsOrderDelivered = undefined;
        this.TimeIntervalToStartMovingInSeconds = undefined;
        this.TimeIntervalToDeliveryInSeconds = undefined;
        this.StartLocationLatitude = undefined;
        this.StartLocationLongitude = undefined;
        this.DeliveryLocationLatitude = undefined;
        this.DeliveryLocationLongitude = undefined;
        this.errorMessage = undefined;
        this.infoMessage = undefined;
        this.isLoading = false;
    }

    _validateTmoForm() {
        if (!this.tmoForm.$valid) {
            return;
        }
        if (this.tmoForm.OrderNumber.$viewValue === undefined) {
            this.tmoForm.OrderNumber.$setTouched();
            this.tmoForm.OrderNumber.$setValidity('required', false);
        }
    }

    _clearTmoForm() {
        this.values.OrderNumber = '';
        this.clearValidationErrors();
        this._clearTmoDisplay();
        this.tmoForm.$setPristine();
        this.submitClicked = undefined;
    }
}

const trackMyOrderGuestFormComponentDefinition = {
    controller: ['$scope', '$state', '$timeout', 'TrackMyOrderService', 'AnalyticsService', 'MoveFocus', TrackMyOrderGuestFormController],
    template: require('./trackmyorder-guest-form.component.html').trim(),
};

module.exports = {
    TrackMyOrderGuestFormController,
    trackMyOrderGuestFormComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/trackmyorder/trackmyorder-guest-form.component.js